const MOUSE_POSITION = "mousePosition"
const TOUCH_POSITION = "touchPosition"

const initialState = {
  mousePosition: { x: null, y: null },
  touchPosition: { x: null, offsetX: null, y: null, offsetY: null },
}

export const setMousePosition = obj => {
  return {
    type: MOUSE_POSITION,
    obj,
  }
}

export const setTouchPosition = obj => {
  return {
    type: TOUCH_POSITION,
    obj,
  }
}

export default (state = initialState, action) => {
  switch (action.type) {
    case MOUSE_POSITION:
      return Object.assign({}, state, {
        mousePosition: action.obj,
      })
    case TOUCH_POSITION:
      return Object.assign({}, state, {
        touchPosition: action.obj,
      })
    default:
      return state
  }
}
